import { Inject, Injectable } from '@angular/core';
import { InsurerMeta, InsurerMetaDef } from '@lockton-apps/shared/interfaces';
import { INSURER_META_DATA } from './insurer-meta';
import { get } from 'lodash';

@Injectable()
export class InsurerMetaService {
  private static placeholder: Partial<InsurerMeta> = {
    name: undefined,
    description: undefined,
  };

  constructor(
    @Inject(INSURER_META_DATA)
    private readonly insurerMeta: InsurerMetaDef
  ) {}

  get(insurer: number, portalId: number, cob: number): Partial<InsurerMeta> {
    return get(
      this.insurerMeta,
      [portalId, cob, insurer],
      get(
        this.insurerMeta,
        [portalId, 'DEFAULT', insurer],
        InsurerMetaService.placeholder
      )
    );
  }
}
